module.exports = __webpack_public_path__ + "static/img/jiangxu_hong.5c8e253b.svg";